import { z } from "zod";

export const doctorInformationSchema = z.object({
  doctor: z.object({
    firstName: z.string(),
    lastName: z.string(),
    specialty: z.string(),
    npi: z.string(),
    phoneNumber: z.string(),
    faxNumber: z.string(),
    addressLineOne: z.string().min(1, { message: "Address is required" }),
    addressLineTwo: z.string().optional(),
    practiceAddress: z.string(),
    city: z.string().min(1, { message: "City is required " }),
    state: z.string().min(1, { message: "Please select a state" }),
    zipCode: z.string().regex(/^\d{5}$/, "ZIP Code must be a 5-digit number"),
  }),
  hasGoogleMatch: z.boolean().refine((val) => val, {
    message: "You must confirm that the information matches Google.",
  }),
});

export type DoctorInformationFormType = z.infer<typeof doctorInformationSchema>;
